import React from "react";
import Modal from "react-modal";

import { triplePSDatasource } from "../../../datasource";

import "./ReceiptModal.scss";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
    maxWidth: "640px",
    width: "90%",
    maxHeight: "85vh",
    padding: "0",
  },
};

interface Props {
  receiptId: string | null;
  onClose: () => void;
}

// Fetches and displays a driver receipt photo. The backend returns the image as
// a data-URL (data:image/jpeg;base64,...) via getReceiptImage; a fetch failure
// (e.g. no receipt stored) shows a message rather than a broken image.
export function ReceiptModal({ receiptId, onClose }: Props) {
  const [src, setSrc] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  // Click-to-zoom: toggles the image between fit-to-modal and natural size.
  // Reset whenever a new receipt loads.
  const [zoomed, setZoomed] = React.useState(false);

  React.useEffect(() => {
    if (!receiptId) return;
    let cancelled = false;
    setLoading(true);
    setError(false);
    setSrc(null);
    setZoomed(false);
    triplePSDatasource
      .getReceiptImage(receiptId)
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [receiptId]);

  return (
    <Modal
      isOpen={receiptId !== null}
      onRequestClose={onClose}
      style={modalStyles}
      contentLabel="Driver receipt"
    >
      <div className="driver-receipt-modal">
        <div className="driver-receipt-modal-header">
          <h3>Driver receipt</h3>
          <button
            className="driver-receipt-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="driver-receipt-modal-body">
          {loading && (
            <div className="driver-receipt-modal-loading">
              Loading receipt…
            </div>
          )}
          {error && (
            <div className="driver-receipt-modal-error">
              No receipt available.
            </div>
          )}
          {src && (
            <img
              src={src}
              alt="Driver receipt"
              className={`driver-receipt-modal-img ${zoomed ? "zoomed" : ""}`}
              title={zoomed ? "Click to zoom out" : "Click to zoom in"}
              onClick={() => setZoomed((z) => !z)}
            />
          )}
        </div>
      </div>
    </Modal>
  );
}
